export default __webpack_public_path__ + "static/media/banner_marketing1.26458678.jpeg";